const About: React.FC = () => {
  return (
    <div className="flex h-dvh w-full items-center justify-center bg-slate-900 px-[25px]">
      <div className="border-theme flex max-h-[90dvh] min-h-[90dvh] grow flex-col overflow-y-scroll border p-[30px] tracking-wide text-white">
        <p>
          <div className="exile-regular float-left mr-[20px] text-8xl leading-none">
            Y?
          </div>
          is a personal project that took inspiration from the social media app
          that we know named X. This project is mostly an attempt to reproduce
          X's basic features and aims to give users at the very least a bare
          bones feel of a social media app via my version (clone) of X's UI. The
          development of this app took 7 - 8 mos to complete through trial and
          error/experimentation with many different libraries, frameworks, and
          ideas - one example is the use of custom web components in typescript
          which helped me build this app's rich text input and some other
          components.
        </p>
        <br />
        <p>Technologies used:</p>
        <div className="pl-[30px]">
          <p>Frontend:</p>
          <ul className="list-disc pl-[30px]">
            <li>Typescript</li>
            <li>Typescript Compiler</li>
            <li>Vite</li>
            <li>React</li>
            <li>React-Router</li>
            <li>Redux Toolkit-Query</li>
            <li>CSS3</li>
            <li>Tailwind</li>
            <li>Custom Web Components</li>
            <li>Zod</li>
          </ul>
          <br />
          <p>Backend:</p>
          <ul className="list-disc pl-[30px]">
            <li>Typescript</li>
            <li>Typescript Compiler</li>
            <li>Nodejs-Express</li>
          </ul>
          <br />
          <p>Database:</p>
          <ul className="list-disc pl-[30px]">
            <li>MySQL</li>
          </ul>
          <br />
          <p>Media Storage:</p>
          <ul className="list-disc pl-[30px]">
            <li>Cloudinary</li>
          </ul>
          <br />
          <p>Version Control:</p>
          <ul className="list-disc pl-[30px]">
            <li>Git/Github</li>
          </ul>
          <br />
          <p>Hosting:</p>
          <ul className="list-disc pl-[30px]">
            <li>Hostinger Ubuntu Linux VPS with Nodejs and Openlitespeed</li>
            <li>Frontend: y-app.eabcdev.com</li>
            <li>Backend: twitter-clone-backend.eabcdev.com</li>
          </ul>
          <br />
        </div>
        <br />
        <p>Available features:</p>
        <ul className="list-disc pl-[30px]">
          <li>JWT cookie based user auth</li>
          <li>user registration</li>
          <li>login-logout</li>
          <li>create-delete post (post with/without text or photo - max 2)</li>
          <li>create-delete reply</li>
          <li>like-unlike</li>
          <li>user profile info change</li>
          <li>user and header picture upload</li>
          <li>follow-unfollow</li>
          <li>search user</li>
          <li>light-dark mode</li>
          <li>mobile/desktop screens responsive</li>
        </ul>
        <br />
        <p>Possible future additions:</p>
        <ul className="list-disc pl-[30px]">
          <li>email verification (temporarily removed)</li>
          <li>JWT Cookie refresh on load - stay logged in option</li>
          <li>track device, currently logged in device</li>
          <li>
            user registration-login captcha/6 digit code sending to email or txt
          </li>
          <li>real time notifications</li>
          <li>use of emojis and GIFs</li>
          <li>text translation</li>
          <li>usage of pinyin, kanji, katakana etc.</li>
          <li>
            copy-cut-paste, text highlight for drag drop in mobile (blocked
            these default features while developing the custom web rich text
            input)
          </li>
          <li>post/reply re-posting</li>
          <li>communities</li>
          <li>complex post filtering/randomization</li>
          <li>track and store user preference</li>
          <li>serve user curated data</li>
          <li>account deactivation</li>
          <li>more options in settings</li>
        </ul>
        <br />
        <p>Developer Portfolio:</p>
        <a target="_blank" href="https://www.eabcdev.com">
          www.eabcdev.com
        </a>
        {/* <p>Code Improvements:</p>
        <ul className="list-disc pl-[30px]">
          <li>refactor repetitive code blocks</li>
          <li>refactor reusable components</li>
          <li>proper documentation and testing</li>
          <li>robust use of schema/types in backend code</li>
        </ul> */}
      </div>
    </div>
  )
}

export default About
